module.exports = __webpack_public_path__ + "d18fee764dc0d67752ec9d6183cd7ce9.pdf";